(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./node/window"), require("./node/extend"));
	else if(typeof define === 'function' && define.amd)
		define(["./node/window", "./node/extend"], factory);
	else if(typeof exports === 'object')
		exports["plumin"] = factory(require("./node/window"), require("./node/extend"));
	else
		root["plumin"] = factory(root["./node/window"], root["./node/extend"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_33__, __WEBPACK_EXTERNAL_MODULE_34__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/